import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function FAQ() {
  return <section className="py-20 bg-[#FAF8F5]" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <h2 className="text-3xl font-bold mb-4 text-[#2C2C2C]" data-id="element-4">
            Is this right for you?
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-5">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-xl border border-[#E5E0D8] shadow-sm" data-id="element-6">
            <h3 className="text-xl font-bold mb-6 flex items-center text-[#FC8EAC]" data-id="element-7">
              <CheckCircle2 className="w-6 h-6 mr-2" data-id="element-8" />
              This IS for you if:
            </h3>
            <ul className="space-y-4" data-id="element-9">
              <li className="flex items-start" data-id="element-10">
                <span className="w-1.5 h-1.5 bg-[#FC8EAC] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-11" />
                <span className="text-[#4A4A4A]" data-id="element-12">
                  You're 55+ and sleep became inconsistent after menopause
                </span>
              </li>
              <li className="flex items-start" data-id="element-13">
                <span className="w-1.5 h-1.5 bg-[#FC8EAC] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-14" />
                <span className="text-[#4A4A4A]" data-id="element-15">
                  You dread the 3am wake-up
                </span>
              </li>
              <li className="flex items-start" data-id="element-16">
                <span className="w-1.5 h-1.5 bg-[#FC8EAC] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-17" />
                <span className="text-[#4A4A4A]" data-id="element-18">
                  You want a system you can do even on low energy
                </span>
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#F0EBE5] p-8 rounded-xl border border-[#E5E0D8]" data-id="element-19">
            <h3 className="text-xl font-bold mb-6 flex items-center text-[#666]" data-id="element-20">
              <XCircle className="w-6 h-6 mr-2" data-id="element-21" />
              Not for you if:
            </h3>
            <ul className="space-y-4" data-id="element-22">
              <li className="flex items-start" data-id="element-23">
                <span className="w-1.5 h-1.5 bg-[#999] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-24" />
                <span className="text-[#666]" data-id="element-25">
                  You need medical diagnosis (sleep apnea, etc.)
                </span>
              </li>
              <li className="flex items-start" data-id="element-26">
                <span className="w-1.5 h-1.5 bg-[#999] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-27" />
                <span className="text-[#666]" data-id="element-28">
                  You want medication/HRT guidance (not included)
                </span>
              </li>
              <li className="flex items-start" data-id="element-29">
                <span className="w-1.5 h-1.5 bg-[#999] rounded-full mt-2 mr-3 flex-shrink-0" data-id="element-30" />
                <span className="text-[#666]" data-id="element-31">
                  You are looking for a "magic pill" supplement
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}